import { useEffect, useState } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

/**
 * Whether the player has asked not to be moved.
 *
 * Read in React rather than enforced from CSS, because the day/night crossover's duration
 * comes off the palette (`theme.fade`) and is interpolated into each styled component as a
 * literal — a `@media` block trying to override it afterwards has to beat every one of those
 * rules, and a blanket `* { transition-duration: 0ms !important }` inside createGlobalStyle
 * does not reliably do it. Zeroing the number at the source is one edit and cannot miss a
 * surface. Animations that are not the crossover carry their own media query, e.g. the town's
 * arrival in City.style.js.
 */
const useReducedMotion = () => {
  const [reduced, setReduced] = useState(() => window.matchMedia?.(QUERY).matches ?? false);

  useEffect(() => {
    const mq = window.matchMedia?.(QUERY);
    if (!mq) return;

    const onChange = event => setReduced(event.matches);
    setReduced(mq.matches);

    // Safari < 14 only has the deprecated form.
    if (mq.addEventListener) {
      mq.addEventListener('change', onChange);
      return () => mq.removeEventListener('change', onChange);
    }
    mq.addListener(onChange);
    return () => mq.removeListener(onChange);
  }, []);

  return reduced;
};

export default useReducedMotion;
